import { useEffect, useState } from "react";

export function useFifaProcessedCardImage(imageUrl: string | null | undefined) {
  const displayUrl = imageUrl?.trim() || null;
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    if (!displayUrl) {
      setIsImageLoaded(false);
      return;
    }

    let cancelled = false;
    setIsImageLoaded(false);

    const img = new Image();
    const markLoaded = () => {
      if (cancelled) return;
      window.requestAnimationFrame(() => {
        if (!cancelled) setIsImageLoaded(true);
      });
    };

    img.onload = markLoaded;
    img.onerror = markLoaded;
    img.src = displayUrl;

    if (img.complete) {
      markLoaded();
    }

    return () => {
      cancelled = true;
    };
  }, [displayUrl]);

  const showShimmer = !displayUrl || !isImageLoaded;

  return {
    displayUrl,
    showShimmer,
    isImageLoaded,
  };
}
